import styled from 'styled-components';
import media from 'styled-media-query';

export const BannerWrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1050; // Acima da maioria dos outros elementos
  background: #36393f; // Cor base do Discord escuro
  color: #dcddde; // Cor de texto clara
  border-radius: 8px;
  padding: 15px 20px;
  padding-right: 50px; // Espaço para o botão de fechar
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  max-width: 450px;
  overflow: hidden; // Para a animação

  ${media.lessThan('medium')`
    bottom: 10px;
    left: 10px;
    right: 10px;
    max-width: none;
    width: auto;
    padding: 12px 15px;
    padding-right: 45px;
  `}
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;

  div {
    margin-right: 15px;
  }

  strong {
    font-weight: 600;
    display: block;
    margin-bottom: 3px;
    color: #fff; // Título mais branco
  }

  p {
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.4;
  }

  ${media.lessThan('medium')`
    p {
      font-size: 0.85rem;
    }
    strong {
      font-size: 0.95rem;
    }
  `}
`;

export const DiscordButton = styled.button`
  background-color: #5865f2; // Cor do Discord
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap; // Impede que o texto quebre
  flex-shrink: 0; // Impede que o botão encolha

  &:hover {
    background-color: #4752c4;
  }

  ${media.lessThan('medium')`
    padding: 6px 10px;
    font-size: 0.9rem;
  `}
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  color: #b9bbbe; // Cor do ícone de fechar
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  display: flex; // Para alinhar o ícone
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
  }

  ${media.lessThan('medium')`
    top: 8px;
    right: 8px;
    font-size: 18px;
  `}
`; 